import React, { useMemo } from "react";
import { HeaderGroup } from "react-table";

interface MultiSelectFilterProps<T extends object> {
  column: HeaderGroup<T>;
}

const MultiSelectFilter = <T extends object>({
  column: { filterValue, setFilter, preFilteredRows, id },
}: MultiSelectFilterProps<T>) => {

  const values = useMemo(
    () => {
      const obj: Record<string, undefined> = {};
      preFilteredRows.forEach(row => {
        const v = row.values[id];
        if (typeof v === "string" && !!v.trim()) {
          obj[v] = void 0;
        }
      });
      const arr = Object.keys(obj).sort();
      return arr;
    },
    [preFilteredRows, id]);

  const anyEmpty = useMemo(
    () => {
      for (let row of preFilteredRows) {
        const v = row.values[id];
        if (!v || (typeof v === "string" && !v.trim())) {
          return true;
        }
      }
      return false;
    },
    [preFilteredRows, id]);

  const checkedValues: string[] = filterValue ?? [];

  const reset = () => {
    setFilter(void 0);
  };

  const toggleValue = (value: string) => {
    const newFilterValue = (filterValue ?? []).slice();
    const index = newFilterValue.indexOf(value);
    if (index !== -1) {
      newFilterValue.splice(index, 1);
    } else {
      newFilterValue.push(value);
    }
    setFilter(newFilterValue.length ? newFilterValue : void 0);
  }

  return (
    <div className="text-neutral fw-5">
      <div className="o-checkbox">
        <label className="d-flex align-items-center mb-0">
          <input
            type="checkbox"
            checked={!checkedValues.length}
            disabled={!checkedValues.length}
            onChange={reset}
          />
          <span className="checkmark"></span>
          <span className="text-uppercase ml-2">All</span>
        </label>
      </div>
      {anyEmpty && (
        <div key="" className="o-checkbox">
          <label className="d-flex align-items-center mt-2 mb-0">
            <input
              type="checkbox"
              color="primary"
              checked={checkedValues.indexOf("") !== -1}
              onChange={e => toggleValue("")}
            />
            <span className="checkmark"></span>
            <span className="text-uppercase ml-2">(None)</span>
          </label>
        </div>)}
      {values.map((value) => {
        return (
          <div key={value} className="o-checkbox">
            <label className="d-flex align-items-center mt-2 mb-0">
              <input
                type="checkbox"
                color="primary"
                value={value}
                checked={checkedValues.indexOf(value) !== -1}
                onChange={e => toggleValue(e.target.value)}
              />
              <span className="checkmark"></span>
              <span className="text-uppercase ml-2">{value}</span>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default MultiSelectFilter;
